var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgComputer = function SvgComputer(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "computer") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/computer"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#8D93AB",
    x: 4,
    y: 5,
    width: 16,
    height: 10,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 6,
    y: 7,
    width: 12,
    height: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.91956109,16 L20.0804389,16 C20.3810796,16 20.6657673,16.1352599 20.8556739,16.368327 L21.7777778,17.5 C22.0984885,17.8935995 22.0394005,18.4726624 21.6458009,18.7933731 C21.4817796,18.9270201 21.2766791,19 21.0651028,19 L2.9348972,19 C2.42718079,19 2.01559532,18.5884145 2.01559532,18.0806981 C2.01559532,17.8691219 2.08857522,17.6640213 2.22222222,17.5 L3.14432611,16.368327 C3.3342327,16.1352599 3.61892041,16 3.91956109,16 Z",
    id: "Rectangle",
    fill: "#8D93AB"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgComputer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/computer.9a38c32b36a23026725bc2ee8193cc8e.svg";